import { useState } from 'react'
import ImagePreviewModal from '../../../image-preview'
import Image, { ImageFolders } from '../../../image'

export default function ImagePreview({ src }) {
  const [isPreviewOpen, setIsPreviewOpen] = useState(false)

  return (
    <div className='wrapper'>
      <Image
        src={src}
        width='200'
        height='200'
        folder={ImageFolders.conversation}
        alt='User Generated Attachement'
        onClick={() => setIsPreviewOpen(true)}
      />

      {isPreviewOpen && (
        <div onMouseDown={(e) => e.stopPropagation()}>
          <ImagePreviewModal
            src={src}
            folder={ImageFolders.conversation}
            onClose={() => setIsPreviewOpen(false)}
          />
        </div>
      )}

      <style jsx>{`
        .wrapper {
          max-width: 20rem;
          max-height: 20rem;
          cursor: zoom-in;
          border-radius: 1rem;
          overflow: hidden;

          :global(img) {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
      `}</style>
    </div>
  )
}
